import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Apply from './Apply';
import Menu from './Menu';

const images = {
  clamatos: '/images/clamatos.png',
  surfturf: '/images/surf and turf tacos.png',
  sea: '/images/aguachile.png',
  grill: '/images/grill.jpg'
};

function Home() {
  return <>
    <section className="hero" id="inicio"><div className="hero-collage"><img src={images.surfturf} alt="Surf and turf tacos"/><img src={images.clamatos} alt="Clamatos"/></div><div className="hero-shade"/><div className="hero-content"><p className="eyebrow light">PUNTO GABILONDO · MUY PRONTO</p><div className="hero-title"><h1>Coral</h1><h2>Reef &<br/>Beef</h2></div><p>Una nueva forma de disfrutar mariscos frescos, cortes selectos y una buena sobremesa.</p><button className="reserve hero-button" onClick={() => document.getElementById('visitanos')?.scrollIntoView({behavior:'smooth'})}>Conoce Coral <span>↓</span></button></div><p className="side-note">MARISCOS · CORTES · CLAMATOS</p></section>

    <section className="visit" id="visitanos"><div><h2>Trabaja<br/><i>con nosotros.</i></h2></div><div><p>Buscamos personas apasionadas por la hospitalidad y la buena mesa. Si quieres ser parte de Coral, escríbenos.</p><Link className="reserve" to="/apply">Enviar solicitud <span>↗</span></Link></div></section>
    <section className="map-section" id="ubicacion"><iframe title="Ubicación Coral" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3364.2955667974093!2d-117.02294572362933!3d32.51825209716393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80d949a58f6a0baf%3A0xc86d04daf342e1da!2sCoral%20Reef%20%26%20Beef!5e0!3m2!1sen!2smx!4v1783907702775!5m2!1sen!2smx" allowFullScreen="" loading="lazy" referrerPolicy="strict-origin-when-cross-origin"></iframe></section>
  </>;
}

export default function App() {
  // The menu page shows its own centered Coral lockup inside the menu sheet,
  // so the site-wide top bar is hidden there to avoid a duplicate logo.
  const { pathname } = useLocation();
  const hideTopbar = pathname === '/menu';

  return <main>
    {!hideTopbar && (
      <header className="topbar">
        <Link className="brand" to="/"><img src="/images/coral-logo.png" alt="Coral Reef & Beef" className="brand-logo"/></Link>
        <nav className="nav">
          <Link to="/">Inicio</Link>
          <Link to="/menu">Menú</Link>
          <Link to="/apply">Trabaja con nosotros</Link>
        </nav>
      </header>
    )}
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/menu" element={<Menu />} />
      <Route path="/apply" element={<Apply />} />
    </Routes>
    <footer><div className="footer-brand">CORAL <small>REEF &<br/>BEEF</small></div><p>© 2026 Coral Reef & Beef · Punto Gabilondo</p><a href="mailto:contacto@coral.restaurant">contacto@coral.restaurant</a></footer>
  </main>;
}
